module.exports = __webpack_public_path__ + "static/media/cavebanana.35012bc7.webp";